
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/burn",
      function () {
        return require("private-next-pages/burn.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/burn"])
      });
    }
  